module.exports = __webpack_public_path__ + "static/img/gb-left.d449498b.jpg";